import React from 'react';
import { FormInputPropsType } from '../../../@types';
import { RegisterOptions } from 'react-hook-form';
import { currencyToNumber, utilNumberToCurrency, parseSearchQuery } from '../../../utils';

const keyDown = ($event: React.KeyboardEvent<HTMLInputElement>, type: FormInputPropsType) => {
  if (type === 'percentage') {
    const validChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ',', 'Backspace', 'Tab'];
    if (!validChars.includes($event.key)) {
      $event.preventDefault();
    }

    const inputValue = ($event.target as HTMLInputElement).value;
    if ($event.key === ',') {
      if (inputValue.includes(',')) {
        $event.preventDefault();
      }
    }
  }

  if (type === 'currency' || type === 'number') {
    const invalidChars = ['-', '+', 'e', 'ArrowUp', 'ArrowDown'];
    if (invalidChars.includes($event.key)) {
      $event.preventDefault();
    }
  }
};

const handleInput = (
  $event: React.FormEvent<HTMLInputElement>,
  type: FormInputPropsType,
  validation: RegisterOptions | undefined
) => {
  if (type === 'textarea' && validation?.maxLength) {
    let maxLengthValue: number | undefined;

    if (typeof validation.maxLength === 'number') {
      maxLengthValue = validation.maxLength;
    } else if (typeof validation.maxLength === 'object' && validation.maxLength.value) {
      maxLengthValue = validation.maxLength.value;
    }
    if (maxLengthValue) {
      if ($event.currentTarget.value.length > maxLengthValue) {
        // Prevent the new character from being added
        $event.currentTarget.value = $event.currentTarget.value.slice(0, maxLengthValue);
      }
    }
  }
};

const handleWheelEvent = () => {
  //event: Event
  //const target = event.target as HTMLInputElement;

  if (document.activeElement && (document.activeElement as HTMLInputElement).type === 'number') {
    (document.activeElement as HTMLInputElement).blur();
  }
};

const handleCurrency = (viewValue: string, action: 'focus' | 'blur', removeDecimals?: boolean) => {
  if (action === 'focus') {
    if (viewValue) {
      viewValue = currencyToNumber(viewValue).toString();
    }
  }
  if (action === 'blur') {
    if (viewValue) {
      viewValue = utilNumberToCurrency(
        parseFloat(viewValue as string),
        true,
        removeDecimals ? 0 : 2
      );
    }
  }
  return viewValue;
};

const handlePercentage = (viewValue: string, action: 'focus' | 'blur') => {
  return action === 'blur' ? (viewValue ? `${viewValue}%` : '') : viewValue.replace('%', '');
};

const formatValue = (
  $event: React.FocusEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>,
  action: 'focus' | 'blur',
  type: FormInputPropsType,
  values?: Record<string, string>,
  removeDecimals?: boolean
) => {
  if (values) {
    //console.log(values)
  }
  let viewValue: string = $event.target.value || '';
  if (type === 'percentage') {
    viewValue = handlePercentage(viewValue, action);
  }
  if (type === 'currency') {
    viewValue = handleCurrency(viewValue, action, removeDecimals);
    $event.target.type = action === 'focus' ? 'number' : 'text';
  }

  $event.target.value = viewValue;
};

const getDefaultValue = (defaultValue: string, force = false): string => {
  return parseSearchQuery(window.location.search)[`prefill`] === 'true' || force
    ? defaultValue
    : '';
};

export { keyDown, handleInput, handleWheelEvent, formatValue, getDefaultValue };
